import { App } from '@lmt/unicorn-shared/app/configureApp';
import { getSentryOptions } from '@lmt/unicorn-shared/app/configureSentry';
import { APP_VERSION } from '@lmt/unicorn-shared/app/constants/constants';
import { FeatureFlags } from '@lmt/unicorn-shared/app/constants/featureFlags';
import { initMatomo } from '@lmt/unicorn-shared/app/helpers/matomo';
import * as Sentry from '@sentry/react';
import React from 'react';
import 'react-app-polyfill/ie11';
// enabling Stable polyfill causes issues with Date.toISOString
// (because it gets overridden by polyfill AFTER calling loadSavedTimezoneIfPresent)
// import 'react-app-polyfill/stable';
import { initWebStorage } from './init';
import * as serviceWorker from './serviceWorker';
import ReactDOM from 'react-dom';
import { BUILD_SENTRY_DSN } from '@lmt/shared-types';

initWebStorage();
Sentry.init(getSentryOptions(APP_VERSION, BUILD_SENTRY_DSN));
initMatomo(FeatureFlags.MatomoUrl, FeatureFlags.MatomoSiteId);

const container = document.getElementById('root')!;
const app = (
  <React.StrictMode>
    <App
      appType={'web'}
      backendStartFailed={false}
      // initializeResult={initialize('')}
    />
  </React.StrictMode>
);
// React 18 migration
// const root = createRoot(container);
// root.render(app);
ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
